import React from "react"
import { Link } from "gatsby"

const MenuStatic = () => (
    <div className="main_menu">
        <Link to="/about-us">
            About Us
            <ul>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/faqs">FAQs</Link></li>
                <li><Link to="/we-welcome-dogs">We Welcome Dogs</Link></li>
            </ul>
        </Link>
        <Link to="/">
            Cottages
            <ul>
                <li><Link to="/the-farmhouse">The Farmhouse</Link></li>
                <li><Link to="/the-owl-barn">The Owl Barn</Link></li>
                <li><Link to="/the-granary">The Granary</Link></li>
                <li><Link to="/woodpecker-cottage">Woodpecker Cottage</Link></li>
            </ul>
        </Link>
        <Link to="/availability">Availability & Booking</Link>
        <Link to="/testimonials">Testimonials</Link>
        <Link to="/explore-anglesey">
            Explore Anglesey
            <ul>
                <li><Link to="/eating-out">Eating Out</Link></li>
                <li><Link to="/eating-in">Eating In</Link></li>
                <li><Link to="/outside-activities">Outside Activities</Link></li>
                <li><Link to="/rainy-day-activities">Rainy Day Activities</Link></li>
                <li><Link to="/shopping">Shopping</Link></li>

            </ul>
        </Link>
    </div>
)

export default MenuStatic